/* "Clairière" pre-home (defer): orchestrates the veil's exit.
   The pre-paint bootstrap (visibility, background, is-on) lives in bq-prepaint.js. */
(function () {
  var veil = document.getElementById('BqPorte');
  if (!veil || !veil.classList.contains('is-on')) return;
  var st = veil._bq || {};
  var doc = document.documentElement;

  var BLOOM = 860; // full bloom (f4 delay + duration)
  var HOLD = 80;   // breath before the passage
  var CAP = 1600;  // cap, from the start of the bloom: past this the veil outlasts
                   // its usefulness (a Shopify page paints above-the-fold anyway)
  var OUTRO = 1080; // veil removal; the wipe already clears it at ~1030ms
  var bloomAt = null;
  var loadReady = false, timer = null, gone = false;

  function out() {
    if (gone) return; gone = true;
    if (timer) { clearTimeout(timer); timer = null; }
    veil.classList.add('is-open');
    doc.style.background = st.prevBg || '';
    setTimeout(function () {
      if (veil.parentNode) veil.parentNode.removeChild(veil);
    }, OUTRO);
  }

  // Never exit before floor (bloom played in full). Loaded uses floor, otherwise ceil.
  function plan() {
    if (gone || bloomAt == null) return;
    var now = Date.now();
    var floor = bloomAt + BLOOM + HOLD;
    var ceil = bloomAt + CAP;
    var target = loadReady ? floor : ceil;
    if (target < floor) target = floor;
    if (target > ceil) target = ceil;
    if (timer) clearTimeout(timer);
    timer = setTimeout(out, Math.max(0, target - now));
  }

  // Anchor: the bloom's real release, reported by the bootstrap (it holds the
  // animation paused until frames are actually being painted). No guessing here:
  // the floor below therefore guarantees the bloom is seen end to end.
  function anchor(t) { if (bloomAt == null) { bloomAt = t; plan(); } }
  if (st.bloomAt) anchor(st.bloomAt);
  else st.onBloom = function () { anchor(st.bloomAt || Date.now()); };

  // Absorb font loading before allowing the exit.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { loadReady = true; plan(); });
  } else {
    loadReady = true; plan();
  }

  var opts = { once: true, capture: true, passive: true };
  addEventListener('pointerdown', out, opts);
  addEventListener('keydown', out, opts);
  addEventListener('wheel', out, opts);
  addEventListener('touchmove', out, opts);

  veil._orchestrated = true; // disarm the inline safety net (last: setup complete)
})();
